import { redirect } from '@tanstack/react-router';

import { useAuthStore } from '@/stores/authStore';

/**
 * TanStack Router beforeLoad guard: deny access when the signed-in user
 * matches one of the listed roles. Use it on routes a role technically
 * could read (permission-wise) but shouldn't navigate to. Pair with the
 * sibling `hideForRoles` flag on the nav config so the link is also
 * hidden in the sidebar.
 */
export function forbidRoles(roles: readonly string[]): void {
  const { user } = useAuthStore.getState();
  if (user?.role && roles.includes(user.role)) {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/unauthorized' });
  }
}
